import { getUnixTime } from 'date-fns/getUnixTime';
import { camelcaseKeys } from 'src/utils/camelize-keys';
import { decamelizeKeys } from 'src/utils/decamelize-keys';
import {
  removeReadOnlyFields,
  timestampToDate,
} from 'src/utils/fieldNormalizers';

import { Conversation, Message, Recipient, ScheduledMessage } from './_types';

export function normalizeConversation(conversation: any): Conversation {
  const camelized = camelcaseKeys(conversation, { deep: true });
  return camelized;
}

export function denormalizeConversation(
  conversation: Partial<Conversation>
): any {
  return decamelizeKeys(conversation, { deep: true });
}

export function normalizeMessage(message: any): Message {
  const camelized = camelcaseKeys(message, { deep: true });
  return {
    ...camelized,
    ...(camelized.createdAt
      ? { createdAt: timestampToDate(camelized.createdAt) }
      : {}),
    ...(camelized.editedAt
      ? { editedAt: timestampToDate(camelized.editedAt) }
      : {}),
  };
}

export function denormalizeMessage(message: Partial<Message>): any {
  const decamelized = decamelizeKeys(message, { deep: true });
  removeReadOnlyFields(decamelized, ['edited_at']);
  return decamelized;
}

export function normalizeScheduledMessage(message: any): ScheduledMessage {
  const camelized = camelcaseKeys(message, { deep: true });
  return {
    ...camelized,
    ...(camelized.deliverAt
      ? { deliverAt: timestampToDate(camelized.deliverAt) }
      : {}),
    ...(camelized.expiresOn
      ? { expiresOn: timestampToDate(camelized.expiresOn) }
      : {}),
    ...(camelized.deliveredAt
      ? { deliveredAt: timestampToDate(camelized.deliveredAt) }
      : {}),
  };
}

export function denormalizeScheduledMessage(
  message: Partial<ScheduledMessage>
): any {
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const { senderId, ...rest } = message;
  const decamelized = decamelizeKeys(rest, { deep: true });

  return decamelizeKeys({
    ...decamelized,
    ...(message.deliverAt
      ? { deliver_at: getUnixTime(message.deliverAt) }
      : {}),
    ...(message.expiresOn
      ? { expires_on: getUnixTime(message.expiresOn) }
      : {}),
  });
}

export function normalizeRecipient(recipient: any): Recipient[] {
  const camelized = camelcaseKeys(recipient, { deep: true });
  return camelized;
}
